import { Integration, WrappedFunction } from '@sentry/types';

let originalFunctionToString: () => void;

/**
 * 本集成只是将官方的functionToString的实现
 * 从直接赋值改成defineProperty
 * 因为微信小程序不允许直接赋值给全局变量
 * @see https://github.com/getsentry/sentry-javascript/blob/5.15.4/packages/core/src/integrations/functiontostring.ts
 */
/** Patch toString calls to return proper name for wrapped functions */
export class FunctionToString implements Integration {
  /**
   * @inheritDoc
   */
  public name: string = FunctionToString.id;

  /**
   * @inheritDoc
   */
  public static id: string = 'FunctionToString';

  /**
   * @inheritDoc
   */
  public setupOnce(): void {
    originalFunctionToString = Function.prototype.toString;

    Object.defineProperty(Function.prototype, 'toString', {
      value: function(this: WrappedFunction, ...args: any[]): string {
        const context = this.__sentry_original__ || this;
        // tslint:disable-next-line:no-unsafe-any
        return originalFunctionToString.apply(context, args);
      }
    })
  }
}